/* THE HOME TEAM — Theme JS */
(function() {
  'use strict';

  /* ── Scroll Reveal ───────────────────────────────────── */
  function initScrollReveal() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.reveal').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* ── Header scroll state ─────────────────────────────── */
  function initHeader() {
    var header = document.querySelector('.tht-header');
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile Nav ──────────────────────────────────────── */
  function initMobileNav() {
    var toggle = document.querySelector('.tht-menu-toggle');
    var nav = document.querySelector('.tht-mobile-nav');
    var close = document.querySelector('.tht-mobile-nav__close');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function() { nav.classList.add('open'); });
    if (close) close.addEventListener('click', function() { nav.classList.remove('open'); });
    nav.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function() { nav.classList.remove('open'); });
    });
  }

  /* ── Product Gallery ─────────────────────────────────── */
  function initGallery() {
    var mainImg = document.querySelector('.tht-gallery__main-img');
    var thumbs = document.querySelectorAll('.tht-gallery__thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Upgrade the thumbnail URL from 200x to 1200x to avoid blurry main image
        var fullSrc = thumb.src
          .replace(/_200x\./,  '_1200x.')
          .replace(/_200x@/,   '_1200x@')
          .replace(/\/200x\./,  '/1200x.')
          .replace(/\?width=200/, '?width=1200');
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = fullSrc;
          mainImg.style.opacity = '1';
        }, 200);
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ── Sticky ATC ──────────────────────────────────────── */
  function initStickyATC() {
    var atcBtn = document.querySelector('.tht-atc-btn');
    var stickyBar = document.querySelector('.tht-sticky-atc');
    if (!atcBtn || !stickyBar) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(atcBtn);
  }

  /* ── Toast ───────────────────────────────────────────── */
  window.thtToast = function(message) {
    var existing = document.querySelector('.tht-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'tht-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toast.classList.add('show');
      });
    });
    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() { toast.remove(); }, 400);
    }, 3000);
  };

  /* ── Marquee duplicate ───────────────────────────────── */
  function initMarquee() {
    var track = document.querySelector('.tht-marquee__track');
    if (!track) return;
    // Already triplicated in Liquid, just ensure animation runs
  }

  /* ── Cart Count ─────────────────────────────────────── */
  function updateCartCount(count) {
    var badges = document.querySelectorAll('#tht-cart-count, #tht-cart-count-mobile');
    badges.forEach(function(badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
      // Show/hide badge with animation
      if (count === 0) {
        badge.style.opacity = '0';
        badge.style.transform = 'scale(0)';
      } else {
        badge.style.opacity = '1';
        badge.style.transform = 'scale(1)';
        // Pulse animation on update
        badge.style.transition = 'none';
        badge.style.transform = 'scale(1.4)';
        setTimeout(function() {
          badge.style.transition = 'transform 0.2s';
          badge.style.transform = 'scale(1)';
        }, 50);
      }
    });
  }

  function initCartCount() {
    // Set initial data-count attributes so CSS [data-count="0"] rule applies
    var badges = document.querySelectorAll('#tht-cart-count, #tht-cart-count-mobile');
    badges.forEach(function(badge) {
      var count = parseInt(badge.textContent.trim(), 10) || 0;
      badge.setAttribute('data-count', count);
      if (count === 0) {
        badge.style.opacity = '0';
        badge.style.transform = 'scale(0)';
      }
    });

    // Poll Shopify cart API for live count updates (catches quantity changes, removals, etc.)
    function fetchCartCount() {
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function(r) { return r.json(); })
        .then(function(cart) { updateCartCount(cart.item_count); })
        .catch(function() {});
    }

    // Refresh count whenever the page becomes visible (back/forward navigation)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) fetchCartCount();
    });

    // Refresh on focus (covers browser back button on some browsers)
    window.addEventListener('pageshow', function(e) {
      fetchCartCount();
    });

    // Intercept Shopify AJAX cart add calls and update count
    var origFetch = window.fetch;
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function(response) {
        if (url.indexOf('/cart/add') !== -1 ||
            url.indexOf('/cart/change') !== -1 ||
            url.indexOf('/cart/update') !== -1 ||
            url.indexOf('/cart/clear') !== -1) {
          // Clone response so it can still be consumed by caller
          response.clone().json().then(function(data) {
            if (data && typeof data.item_count !== 'undefined') {
              updateCartCount(data.item_count);
            } else {
              // For /cart/add which returns the added item, re-fetch cart
              fetchCartCount();
            }
          }).catch(function() { fetchCartCount(); });
        }
        return response;
      });
    };

    // Also intercept XMLHttpRequest for themes that use XHR instead of fetch
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._thtUrl = url;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function() {
      var xhr = this;
      var url = xhr._thtUrl || '';
      if (url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1) {
        xhr.addEventListener('load', function() {
          fetchCartCount();
        });
      }
      return origSend.apply(this, arguments);
    };

    // Initial fetch to ensure count is accurate on page load
    fetchCartCount();
  }

  /* ── Init ────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initScrollReveal();
    initHeader();
    initMobileNav();
    initGallery();
    initStickyATC();
    initMarquee();
    initCartCount();
  });

})();
